import {
    SET_PORTFOLIO_VALUE,
    SET_OPEN_POSITIONS_DAY,
    SET_OPEN_POSITIONS_MONTH,
    SET_CLOSED_POSITIONS_DAY,
    SET_CLOSED_POSITIONS_MONTH,
    SET_UNREALIZED_PROFITS,
    SET_REALIZED_PROFITS,
} from "./actions";

const initialState = {
    portfolioValue: 0,
    openPositionsDay: 0,
    openPositionsMonth: 0,
    closedPositionsDay: 0,
    closedPositionsMonth: 0,
    unrealizedProfits: 0,
    realizedProfits: 0,
};

export default function metricsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PORTFOLIO_VALUE:
            return { ...state, portfolioValue: action.payload };
        case SET_OPEN_POSITIONS_DAY:
            return { ...state, openPositionsDay: action.payload };
        case SET_OPEN_POSITIONS_MONTH:
            return { ...state, openPositionsMonth: action.payload };
        case SET_CLOSED_POSITIONS_DAY:
            return { ...state, closedPositionsDay: action.payload };
        case SET_CLOSED_POSITIONS_MONTH:
            return { ...state, closedPositionsMonth: action.payload };
        case SET_UNREALIZED_PROFITS:
            return { ...state, unrealizedProfits: action.payload };
        case SET_REALIZED_PROFITS:
            return { ...state, realizedProfits: action.payload };
        default:
            return state;
    }
}
